import { ISectionsVisibility } from 'api/types';

// Весь раздел не пуст, если хотя бы один раздел не пуст
export const checkSectionEmptiness = (emptyDataMap: Partial<Record<keyof ISectionsVisibility, boolean>>): boolean =>
  !Object.values(emptyDataMap).some((item) => item === false);
